<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('archive.file_management')"
      :columns="columns"
      :column_search="true"
      resource_url="/archive/expedient/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("archive.new_expedient") }}</span>
        </button>
      </template>
    </generic-table>
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_date,
} from "@/utils";

export default {
  name: "ExpedientsDatatable",
  components: {
    GenericTable,
  },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("archive.expedient_number"),
          searchable: true,
          name: "expedient_number",
          data: (row) => {
            return row.expedient_number || "";
          },
        },
        {
          title: v.$t("archive.expedient_name"),
          searchable: true,
          name: "name",
          data: (row) => {
            return row.name || "";
          },
        },
        {
          title: v.$t("archive.customer"),
          searchable: false,
          name: "$customer.name$",
          data: (row) => {
            return row.customer?.name || "";
          },
        },
        {
          title: v.$t("archive.status"),
          searchable: false,
          data: (row) => {
            const statusColors = {
              active: "is-success",
              pending: "is-warning",
              closed: "is-dark",
              archived: "is-light",
            };
            const colorClass = statusColors[row.status] || "is-light";
            return (
              '<span class="tag ' +
              colorClass +
              '">' +
              v.$t("archive.status_" + row.status) +
              "</span>"
            );
          },
        },
        {
          title: v.$t("archive.priority"),
          searchable: false,
          data: (row) => {
            const priorityColors = {
              low: "is-info",
              medium: "is-primary",
              high: "is-warning",
              urgent: "is-danger",
            };
            const colorClass = priorityColors[row.priority] || "is-light";
            return (
              '<span class="tag ' +
              colorClass +
              '">' +
              v.$t("archive.priority_" + row.priority) +
              "</span>"
            );
          },
        },
        {
          title: v.$t("archive.file_count"),
          searchable: false,
          data: (row) => {
            return row.file_count || 0;
          },
        },
        {
          title: v.$t("create_date"),
          searchable: false,
          data: (row) => {
            return format_date(row.create_date);
          },
        },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { expedient_id: row.expedient_id },
                tooltip: v.$t("details"),
                icon: "fa fa-eye",
                icon_class: "is-small",
                click: function (e) {
                  v.$refs.expedient_detail_modal.show(e.detail.expedient_id);
                },
              },
              {
                args: { expedient_id: row.expedient_id },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  v.edit(row);
                },
              },
              {
                args: { expedient_id: row.expedient_id },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  if (row.file_count > 0) {
                    error_message(
                      v.$t("archive.cannot_delete_expedient_with_files")
                    );
                    return;
                  }
                  confirm_deletion_dialog(
                    v.$t("archive.confirm_delete_expedient"),
                    v,
                    () => {
                      del("/archive/expedient", {
                        expedient_id: row.expedient_id,
                      })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    format_date,
    create() {
      let v = this;
      v.$refs.expedient_modal.show_modal();
    },
    edit(row) {
      let v = this;
      v.$refs.expedient_modal.show_modal(row);
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
